import React, { useState, useEffect, useRef } from "react";
import { useLocation, useParams } from "react-router-dom";
import SectionHeader from "../../components/sectionHeader/sectionHeader";
import InputTextfield from "../../components/inputs/inputTextfield/inputTextfield.jsx";
import Input from "../../components/inputs/input/input.jsx";
import Button from "../../components/button/button";
import Tabs from "../../components/tabs/tabs";
import Badge from "../../components/badge/badge";
import FileList from "../../components/fileList/fileList.jsx";
import Notification from "../../components/notification/notification.jsx";
import Popup from "../../components/popup/popup";
import { getApiInstance } from "../../utils/api";
import { TiDeleteOutline } from "react-icons/ti";
import { formatDateComment } from "../../utils/utils.js";
import { formatCategories } from "../../utils/categoryUtils.js";

import img1 from "../../assets/img/detalleMueble1.png";
import img2 from "../../assets/img/detalleMueble2.png";
import img3 from "../../assets/img/detalleMueble3.png";
import img4 from "../../assets/img/detalleMueble4.png";
import img5 from "../../assets/img/detalleMueble5.png";
import { useSearchParams } from "react-router-dom";

import "./detalleMueble.scss";

export default function DetalleMueble({ user }) {
  const [searchParams] = useSearchParams();
  const { codMueble } = useParams();
  const [mainImage, setMainImage] = useState(img1);
  const [activeTab, setActiveTab] = useState("details");
  const [comment, setComment] = useState("");
  const [comments, setComments] = useState([]);
  const [selectedComentarioFiles, setSelectedComentarioFiles] = useState([]);
  const [inputFileComentariosText, setInputFileComentariosText] = useState(
    "Selecciona un archivo"
  );
  const notificationRef = useRef(null);
  const api = getApiInstance();
  const [visibleComments, setVisibleComments] = useState(5);

  const [muebleData, setMuebleData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [comentarioAEliminar, setComentarioAEliminar] = useState();
  const [archivoComentarioAEliminar, setArchivoComentarioAEliminar] =
    useState();
  const location = useLocation();
  const { hash, pathname, search } = location;
  const [historialCambios, setHistorialCambios] = useState([]);
  const [existFile, setExistFile] = useState(false)
  const [existDwgFile, setExistDwgFile] = useState(false)
  const [isFullScreen, setIsFullScreen] = useState(false);
  console.log(user);

  const images = [img1, img2, img3, img4, img5];
  const categoriasMapping = {
    TiendasTop: "Tiendas Top",
    TiendasLight: "Tiendas Light",
    TiendasLow: "Tiendas Low",
    General: "General",
    Banner: "Banners",
    Senalizacon: "Señalización",
  };

  useEffect(() => {
    const fetchHistorialCambios = async () => {
      try {
        const response = await api.get(
          `/api/Mueble/muebles/${codMueble}/historialDiferencias`
        );
        setHistorialCambios(response.data);
      } catch (error) {
        console.error("Error al obtener el historial de cambios:", error);
      }
    };

    if (codMueble) {
      fetchHistorialCambios();
    }

    const fetchMuebleData = async () => {
      setLoading(true);
      const api = getApiInstance();
      try {
        const response = await api.get(
          `/api/Mueble/GetMuebleDetailsById/${codMueble}/${user.codEmpresa}`
        );
        setMuebleData(response.data);
        setError(null);
        setExistFile(false);
        setExistDwgFile(false);

        checkPdfExists(response.data).then((exists) => {
          if (exists) {
            setExistFile(true)
          }
        });

        checkDwgExists(response.data).then((exists) => {
          if (exists) {
            setExistDwgFile(true)
          }
        });
      } catch (error) {
        setError("Error al obtener datos del mueble.");
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    const fetchComentarios = async () => {
      const api = getApiInstance();
      try {
        const response = await api.get(
          `/api/Mueble/GetAllComentarios/${codMueble}`
        );

        setComments(response.data);

        console.log(response.data);

        setError(null);
      } catch (error) {
        console.error(error);
      }
    };

    if (codMueble) {
      fetchMuebleData();
      fetchComentarios();
    }
  }, [codMueble]);
  useEffect(() => {
    const tabParam = searchParams.get("tab");
    if (tabParam) {
      setActiveTab(tabParam);
    }
  }, [searchParams]);

  const handleAddComment = async () => {
    if (comment.trim()) {
      try {
        const fecha = new Date();
        const formData = new FormData();
        formData.append("CodMueble", muebleData.codMueble);
        formData.append("Comentario", comment);
        formData.append("Fecha", fecha.toLocaleString());
        selectedComentarioFiles.forEach((file) => {
          formData.append("RutasArchivos", file);
        });

        let response = await api.post(`/api/Mueble/Comentario`, formData);

        if (response.status === 200) {
          notificationRef.current.addNotification(
            "Comentario creado correctamente.",
            "success"
          );

          const comentario = {
            codComentario: response.data.codComentario,
            comentario: comment,
            nombreUsuario: "Tú",
            apellidosUsuario: "",
            fecha: fecha,
            rutasArchivos: selectedComentarioFiles,
          };

          setComments([...comments, comentario]);

          await fetchSendNotification(comentario);

          setComment("");
          setSelectedComentarioFiles([]);
        } else {
          notificationRef.current.addNotification(
            "Hubo un error al guardar los cambios.",
            "error"
          );
        }
      } catch (error) {
        console.error("Error al guardar los cambios:", error);
        notificationRef.current.addNotification(
          "Hubo un error al guardar el comentario.",
          "error"
        );
      }
    }
  };

  const handleAddResponse = (commentId, responseText) => {
    setComments(
      comments.map((com) => {
        if (com.id === commentId) {
          return {
            ...com,
            responses: [
              ...com.responses,
              {
                text: responseText,
                author: "Tú",
                date: new Date().toISOString().split("T")[0],
              },
            ],
          };
        }
        return com;
      })
    );
  };

  const handleDownloadPlano = async () => {
    const api = getApiInstance();
    try {
      const response = await api.get(`/api/Mueble/${codMueble}/downloadPlano`, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Plano_Mueble_${codMueble}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error al descargar el plano:", error);
      alert("No se pudo descargar el plano.");
    }
  };

  const handleDownloadPlanoDwg = async () => {
    const api = getApiInstance();
    try {
      const response = await api.get(`/api/Mueble/${codMueble}/download-plano-dwg`, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Plano_Mueble_${codMueble}.dwg`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      notificationRef.current.addNotification(
        "Plano DWG descargado correctamente.",
        "success"
      );
    } catch (error) {
      console.error("Error al descargar el plano DWG:", error);
      notificationRef.current.addNotification(
        "No se pudo descargar el plano DWG.",
        "error"
      );
    }
  };

  const tabs = [
    { id: "details", label: "Detalles" },
    { id: "dotaciones", label: "Dotaciones" },
    { id: "incidencias", label: "Incidencias" },
    { id: "historico", label: "Historico cambios" },
  ];

  useEffect(() => {
    if (selectedComentarioFiles.length === 0) {
      setInputFileComentariosText("Selecciona un archivo");
    } else {
      setInputFileComentariosText(
        `${selectedComentarioFiles.length} ${
          selectedComentarioFiles.length > 1
            ? "archivos seleccionados"
            : "archivo seleccionado"
        }`
      );
    }
  }, [selectedComentarioFiles]);

  if (loading) return <p>Cargando datos del mueble...</p>;
  if (error) return <p>{error}</p>;
  if (!muebleData) return <p>No se encontraron datos del mueble</p>;

  const historicoCambios = [
    {
      fecha: "2024-09-15",
      version: "v.0.1",
      cambios: [
        {
          campo: "Nombre",
          valorAnterior: "Mueble Clásico",
          valorActual: "Mueble Vintage",
        },
        {
          campo: "Dotación",
          valorAnterior: "Estantería de 3 niveles",
          valorActual: "Estantería de 5 niveles",
        },
      ],
    },
    {
      fecha: "2024-08-30",
      version: "v.0.2",
      cambios: [
        {
          campo: "Material",
          valorAnterior: "Madera",
          valorActual: "Metal",
        },
      ],
    },
  ];
  console.log(muebleData);

  const handleComentarioFiles = (event) => {
    const filesArray = Array.from(event.target.files);

    setSelectedComentarioFiles((prevFiles) => [
      ...prevFiles,
      ...filesArray.filter(
        (file) => !prevFiles.some((prevFile) => prevFile.name === file.name)
      ),
    ]);
  };

  const handleDeleteComentarioFile = (file) => {
    setSelectedComentarioFiles((prevFiles) =>
      prevFiles.filter((f) => f.name !== file.name)
    );
  };

  const handleShowMoreComments = () => {
    setVisibleComments(
      (prevVisibleComments) =>
        prevVisibleComments + (visibleComments < comments.length ? +5 : -5)
    );
  };

  const confirmDeleteComentario = (comentario) => {
    setComentarioAEliminar(comentario);
    setIsPopupOpen(true);
  };

  const handleDeleteComment = async () => {
    const api = getApiInstance();

    try {
      await api.delete(
        `/api/Mueble/EliminarComentario/${comentarioAEliminar.codComentario}`
      );
      notificationRef.current.addNotification(
        "Comentario eliminado correctamente.",
        "success"
      );

      setComments((prevComments) =>
        prevComments.filter(
          (comment) =>
            comment.codComentario !== comentarioAEliminar.codComentario
        )
      );

      setIsPopupOpen(false);
    } catch (error) {
      notificationRef.current.addNotification(
        "Error al eliminar el comentario.",
        "error"
      );
      setIsPopupOpen(false);
    }
  };

  // TODO: Poder eliminar cada uno de los archivos de cada comentario, en el back ya está hecho, pero hay que mapear el codArchivoComentario
  const confirmDeleteArchivoComentario = (archivo) => {
    setArchivoComentarioAEliminar(archivo);
    console.log(archivo);
    setIsPopupOpen(true);
  };

  const handleDeleteArchivoComment = async () => {
    const api = getApiInstance();

    try {
      await api.delete(
        `/api/Mueble/EliminarArchivoComentario/${archivoComentarioAEliminar.codArchivoComentario}`
      );
      notificationRef.current.addNotification(
        "Comentario eliminado correctamente.",
        "success"
      );

      setComments((prevComments) =>
        prevComments.filter(
          (comment) =>
            comment.codComentario !== comentarioAEliminar.codComentario
        )
      );

      setIsPopupOpen(false);
    } catch (error) {
      notificationRef.current.addNotification(
        "Error al eliminar el comentario.",
        "error"
      );
      setIsPopupOpen(false);
    }
  };

  const fetchSendNotification = async (comentario) => {
    try {
      const api = getApiInstance();

      const formData = new FormData();

      // Tipos destinatarios
      // None = 0,
      // Admin = 1,
      // Todos = 2,
      // Personalizado = 3

      formData.append("DestinatariosNotificacion", 1);
      formData.append("CodUsuarioNotifica", user.codUsuario);
      formData.append("Mensaje", comentario.comentario);
      formData.append("Titulo", "Nueva notificación");

      // Tipos notificación (sin aplicación en el front por ahora)
      // Info = 0,
      // Warning = 1,
      // Error = 2

      formData.append("TipoNotificacion", 0);
      console.log(pathname);
      formData.append("Enlace", pathname);

      let response = await api.post(`/api/Notificaciones`, formData);

      console.log(response.data);
    } catch (error) {
      console.error("Error adding notifications data:", error);
    }
  };

async function checkPdfExists(mueble) {
  try {
    const headRes = await api.head(mueble.rutaPlano);
    return headRes.status >= 200 && headRes.status < 300
      && headRes.headers['content-type']?.includes('pdf');
  } catch (error) {
    return false;
  }
}

async function checkDwgExists(mueble) {
  try {
    // Verificamos si existe el plano DWG haciendo una llamada HEAD al endpoint
    const response = await api.head(`/api/Mueble/${mueble.codMueble}/download-plano-dwg`);
    return response.status >= 200 && response.status < 300;
  } catch (error) {
    // En produccion el endpoint de descarga permite GET pero puede rechazar HEAD.
    // En ese caso mostramos la accion y dejamos que el GET real valide la descarga.
    if (error.response?.status === 405) {
      return true;
    }

    // Si hay error 404 o cualquier otro, asumimos que no existe
    return false;
  }
}

  return (
    <div className="detalle-mueble">
      <SectionHeader title={`Mueble ${muebleData.referencia}`} />

      <div className="detalle-mueble__container">
        <div className="detalle-mueble__images">
          <div className="detalle-mueble__images__main">
            {/* Botón pantalla completa */}
            {muebleData.rutaPlano && existFile && (
              <button
                className="btn-fullscreen"
                onClick={() => setIsFullScreen(true)}
                style={{
                  position: "absolute",
                  top: 12,
                  right: 12,
                  zIndex: 2,
                  background: "#fff",
                  border: "1px solid #ccc",
                  borderRadius: "50%",
                  width: 40,
                  height: 40,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.12)"
                }}
                title="Ampliar plano a pantalla completa"
              >
                {/* Puedes usar un icono, por ejemplo: */}
                <span style={{fontSize: 22}}>⛶</span>
              </button>
            )}
            {muebleData.rutaPlano && existFile ? (
              <iframe
                src={muebleData.rutaPlano}
                title="Vista previa del plano"
                width="100%"
                height="500px"
                style={{ border: "none" }}
              />
            ) : (
              <p>No hay un plano disponible para este mueble.</p>
            )}

            {/* Modal pantalla completa */}
            {isFullScreen && (
              <div className="fullscreen-modal">
                <button
                  className="btn-close-fullscreen"
                  onClick={() => setIsFullScreen(false)}
                  style={{
                    position: "absolute",
                    top: 20,
                    right: 20,
                    zIndex: 10001,
                    background: "#fff",
                    border: "1px solid #ccc",
                    borderRadius: "50%",
                    width: 40,
                    height: 40,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.12)"
                  }}
                  title="Cerrar pantalla completa"
                >
                  ✕
                </button>
                <iframe
                  src={muebleData.rutaPlano}
                  title="Plano en pantalla completa"
                  width="90%"
                  height="90%"
                  style={{
                    border: "none",
                    background: "#fff",
                    zIndex: 10000,
                    borderRadius: "8px"
                  }}
                />
                {/* Aquí puedes añadir los controles de girar, dibujar, etc. si los tienes */}
              </div>
            )}
          </div>
          {/* <div className="detalle-mueble__images__thumbnails">
                        {images.map((image, index) => (
                            <img
                                key={index}
                                src={image}
                                alt={`Mueble ${index + 1}`}
                                onClick={() => setMainImage(image)}
                                className={`detalle-mueble__images__thumbnails__item ${
                                    image === mainImage ? "active" : ""
                                }`}
                            />
                        ))}
                    </div> */}
        </div>

        <div className="detalle-mueble__info">
          <Tabs tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} />

          <div className="detalle-mueble__info__content">
            {activeTab === "details" && (
              <div className="detalle-mueble__info__details">
                <div className="detalle-mueble__info__details__item">
                  <p className="detalle-mueble__info__details__item__title">
                    Nombre:
                  </p>
                  <span className="detalle-mueble__info__details__item__description">
                    {muebleData.nombreBook}
                  </span>
                </div>
                <div className="detalle-mueble__info__details__item">
                  <p className="detalle-mueble__info__details__item__title">
                    Nombre Inglés:
                  </p>
                  <span className="detalle-mueble__info__details__item__description">
                    {muebleData.nombreBookIngles}
                  </span>
                </div>
                <div className="detalle-mueble__info__details__item">
                  <p className="detalle-mueble__info__details__item__title">
                    Referencia:
                  </p>
                  <span className="detalle-mueble__info__details__item__description">
                    {muebleData.referencia}
                  </span>
                </div>
                <div className="detalle-mueble__info__details__item">
                  <p className="detalle-mueble__info__details__item__title">
                    Familia:
                  </p>
                  <span className="detalle-mueble__info__details__item__description">
                    {muebleData.nombreFamilia}
                  </span>
                </div>
                {/* Oculto  */}
                {/* <div className="detalle-mueble__info__details__item">
                                    <p className="detalle-mueble__info__details__item__title">
                                        CodFamilia:
                                    </p>
                                    <span className="detalle-mueble__info__details__item__description">
                                        {muebleData.codFamilia}
                                    </span>
                                </div> */}
                <div className="detalle-mueble__info__details__item">
                  <p className="detalle-mueble__info__details__item__title">
                    Variante:
                  </p>
                  <span className="detalle-mueble__info__details__item__description">
                    {muebleData.variante}
                  </span>
                </div>
                <div className="detalle-mueble__info__details__item">
                  <p className="detalle-mueble__info__details__item__title">
                    Imagen:
                  </p>
                  <span className="detalle-mueble__info__details__item__description">
                    {formatCategories(muebleData.categorias) ||
                      "No hay categorías asignadas"}
                  </span>
                </div>
                <div className="detalle-mueble__info__details__item">
                  <p className="detalle-mueble__info__details__item__title">
                    Unidad de medida:
                  </p>
                  <span className="detalle-mueble__info__details__item__description">
                    {muebleData.medida}
                  </span>
                </div>
                <div className="detalle-mueble__info__details__item">
                  <p className="detalle-mueble__info__details__item__title">
                    Descripción:
                  </p>
                  <span className="detalle-mueble__info__details__item__description">
                    {muebleData.descripcion || "Sin descripción"}
                  </span>
                </div>
                {(user.codPerfil === "Administrador" ||
                  user.codTipoEmpresa === 1 ||
                  user.codTipoEmpresa === 2) && (
                  <div className="detalle-mueble__info__details__item">
                    <p className="detalle-mueble__info__details__item__title">
                      Precio:
                    </p>
                    <span className="detalle-mueble__info__details__item__description">
                      {muebleData.precio &&
                        `${muebleData.precio} ${user.simbolo}`}
                      {muebleData.isPending && (
                        <Badge
                          label="Precio en revisión"
                          variant="warning"
                          style={{ marginLeft: "8px" }}
                        />
                      )}
                    </span>
                  </div>
                )}
                {user.codPerfil === "Administrador" && (
                  <div className="detalle-mueble__info__details__item">
                    <p className="detalle-mueble__info__details__item__title">
                      Estado:
                    </p>
                    <Badge
                      label={muebleData.estado}
                      variant={
                        muebleData.estado === "Publicado"
                          ? "success"
                          : "warning"
                      }
                    />
                  </div>
                )}
                {existDwgFile && (
                  <div className="detalle-mueble__info__details__actions">
                    <Button 
                      label="Descargar Plano DWG" 
                      onClick={handleDownloadPlanoDwg}
                      variant="filled"
                    />
                  </div>
                )}
              </div>
            )}

            {activeTab === "dotaciones" && (
              <div className="detalle-mueble__info__dotaciones">
                {muebleData.dotaciones.map((dotacion, index) => (
                  <div
                    key={index}
                    className="detalle-mueble__info__dotaciones__dotacion"
                  >
                    <div className="detalle-mueble__info__dotaciones__dotacion__item">
                      <p className="detalle-mueble__info__dotaciones__dotacion__item__title">
                        Código de dotación:
                      </p>
                      <span className="detalle-mueble__info__dotaciones__dotacion__item__description">
                        {dotacion.codDotacion}
                      </span>
                    </div>
                    <div className="detalle-mueble__info__dotaciones__dotacion__item">
                      <p className="detalle-mueble__info__dotaciones__dotacion__item__title">
                        Descripción:
                      </p>
                      <span className="detalle-mueble__info__dotaciones__dotacion__item__description">
                        {dotacion.nombreDotacion}
                      </span>
                    </div>
                    <div className="detalle-mueble__info__dotaciones__dotacion__item">
                      <p className="detalle-mueble__info__dotaciones__dotacion__item__title">
                        Unidades:
                      </p>
                      <span className="detalle-mueble__info__dotaciones__dotacion__item__description">
                        {dotacion.unidades}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {activeTab === "incidencias" && (
              <div className="detalle-mueble__info__comments">
                <div className="detalle-mueble__info__comments__comments-list">
                  {comments.length > 0 ? (
                    <>
                      {comments.slice(0, visibleComments).map((com) => (
                        <div
                          key={com.codComentario}
                          className="detalle-mueble__info__comments__comments-list__item"
                        >
                          <div className="detalle-mueble__info__comments__comments-list__item__info">
                            <div className="detalle-mueble__info__comments__comments-list__item__author">
                              <div className="avatar">
                                <div className="avatar__inner">
                                  {com.nombreUsuario.charAt(0).toUpperCase()}
                                </div>
                              </div>
                              <p>
                                {com.codUsuario === parseInt(user.codUsuario)
                                  ? "Tú"
                                  : `${com.nombreUsuario} ${com.apellidosUsuario}`}
                              </p>
                              <span>({formatDateComment(com.fecha)})</span>
                            </div>
                            <TiDeleteOutline
                              className="file-list__delete-icon"
                              onClick={() => confirmDeleteComentario(com)}
                            />
                          </div>
                          <p className="detalle-mueble__info__comments__comments-list__item__comment">
                            {com.comentario}
                          </p>
                          {com.rutasArchivos !== null &&
                            com.rutasArchivos.length > 0 && (
                              <FileList
                                files={com.rutasArchivos}
                                filesVisible={3}
                                //handleDelete={confirmDeleteArchivoComentario}
                              />
                            )}
                        </div>
                      ))}
                      {visibleComments < comments.length && (
                        <button
                          className="button-show-more-list__button"
                          onClick={handleShowMoreComments}
                        >
                          Ver{" "}
                          {visibleComments < comments.length ? "más" : "menos"}{" "}
                          comentarios
                        </button>
                      )}
                    </>
                  ) : (
                    <p
                      className="detalle-mueble__info__comments__comments-list__item__comment"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        padding: "12px 0",
                        fontWeight: "700",
                      }}
                    >
                      Todavía no hay comentarios en este mueble.
                    </p>
                  )}
                </div>

                {/* Formulario para agregar comentario */}
                <div className="detalle-mueble__info__comments__add-comment">
                  <InputTextfield
                    label="Escribe tu comentario"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    placeholder="Escribe aquí tu comentario..."
                  />
                  <Input
                    type="file"
                    label="Archivo adjunto"
                    name="archivoAdjunto"
                    placeholder={inputFileComentariosText}
                    multipleFiles={true}
                    onChange={handleComentarioFiles}
                  />

                  {selectedComentarioFiles.length > 0 && (
                    <FileList
                      files={selectedComentarioFiles}
                      handleDelete={handleDeleteComentarioFile}
                    />
                  )}
                  <Button
                    label="Enviar comentario"
                    variant="filled"
                    onClick={handleAddComment}
                  />
                </div>
              </div>
            )}
            {activeTab === "historico" && (
              <div className="detalle-mueble__info__historico">
                {historialCambios.length > 0 ? (
                  historialCambios.map((cambio, index) => (
                    <div key={index} className="cambio-item">
                      <h4>
                        Cambio realizado el{" "}
                        {new Date(cambio.fecha).toLocaleDateString()} en v.
                        {cambio.codBook || "N/A"}
                      </h4>
                      <div className="cambio-item__contenedor">
                        <div className="cambio-item__columna antes">
                          <ul>
                            {cambio.diferencias.map((detalle, idx) => (
                              <li key={idx}>
                                <strong>{detalle.campo}:</strong>{" "}
                                {detalle.valorAnterior}
                                <p>Anterior</p>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="cambio-item__columna ahora">
                          <ul>
                            {cambio.diferencias.map((detalle, idx) => (
                              <li key={idx}>
                                <strong>{detalle.campo}:</strong>{" "}
                                {detalle.valorActual}
                                <p>Actual</p>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <p
                    className="detalle-mueble__info__comments__comments-list__item__comment"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      padding: "12px 0",
                      fontWeight: "700",
                    }}
                  >
                    No hay historial de cambios disponible.
                  </p>
                )}
              </div>
            )}
          </div>
          <Notification ref={notificationRef} />
          {isPopupOpen && (
            <Popup
              type="alert"
              alertType="warning"
              titleMessage="Confirmar eliminación"
              alertMessage={`¿Estás seguro de que deseas eliminar el comentario"?`}
              onConfirm={handleDeleteComment}
              onClose={() => setIsPopupOpen(false)}
              confirmLabel="Eliminar"
              cancelLabel="Cancelar"
            />
          )}
        </div>
      </div>
    </div>
  );
}
